var map = {
	"./FiraSans-Bold.ttf": 528,
	"./FiraSans-Medium.ttf": 529,
	"./FiraSans-Regular.ttf": 530,
	"./FiraSans-SemiBold.ttf": 531,
	"./KumbhSans-Bold.ttf": 532,
	"./KumbhSans-Light.ttf": 533,
	"./KumbhSans-Regular.ttf": 534,
	"./NotoEmoji.ttf": 535,
	"./NotoSerif-Regular.ttf": 536,
	"./Quicksand-Bold.ttf": 537,
	"./Quicksand-Light.ttf": 538,
	"./Quicksand-Medium.ttf": 539,
	"./Quicksand-Regular.ttf": 540,
	"./Quicksand-SemiBold.ttf": 541,
	"./Roboto-Black.ttf": 542,
	"./Roboto-BlackItalic.ttf": 543,
	"./Roboto-Bold.ttf": 544,
	"./Roboto-BoldItalic.ttf": 545,
	"./Roboto-Italic.ttf": 546,
	"./Roboto-Light.ttf": 547,
	"./Roboto-LightItalic.ttf": 548,
	"./Roboto-Medium.ttf": 549,
	"./Roboto-MediumItalic.ttf": 550,
	"./Roboto-Regular.ttf": 551,
	"./Roboto-Thin.ttf": 552,
	"./Roboto-ThinItalic.ttf": 553,
	"./SeptemberMornings.ttf": 554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 527;